webpackJsonp([74659487905566],{

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _images = __webpack_require__(147);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubscriptionPage = function SubscriptionPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        style: {
	          fontFamily: "Helvetica, sans-serif",
	          fontSize: 20,
	          background: "#fff",
	          textRendering: "optimizeLegibility"
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        { style: { paddingTop: 50 } },
	        _react2.default.createElement(
	          "div",
	          { style: { width: 260, margin: "0 auto" } },
	          _react2.default.createElement(
	            "a",
	            {
	              href: "/",
	              style: { display: "block", textDecoration: "none", outline: 0 }
	            },
	            _react2.default.createElement("img", {
	              src: _images2.default.logo,
	              alt: "Cliffhanger",
	              style: { width: "100%", maxWidth: "100%" }
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "content page" },
	      _react2.default.createElement(
	        "div",
	        { className: "hero" },
	        _react2.default.createElement(
	          "div",
	          { className: "lockup" },
	          _react2.default.createElement(
	            "div",
	            { className: "heading" },
	            _react2.default.createElement(
	              "h1",
	              { className: "title" },
	              "Subscription Information"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "CLIFFHANGER UNLIMITED SUBSCRIPTIONS: "
	      ),
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          "You can subscribe for unlimited access to entire Cliffhanger catalog for the duration of your subscription"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Cliffhanger offers weekly, monthly, and annual subscriptions"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Weekly subscriptions will be charged at $2.99/week*"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Monthly subscriptions will be charged at $7.99/month*"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Annual subscriptions will be charged at $39.99/year*"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Payment will be charged to iTunes Account at confirmation of purchase"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Subscription automatically renews unless auto-renew is turned off at least 24-hours before the end of the current period"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Account will be charged for renewal within 24-hours prior to the end of the current period"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Subscriptions may be managed by the user and auto-renewal may be turned off by going to the user\u2019s Account Settings after purchase"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "No cancellation of the current subscription is allowed during active subscription period"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Any unused portion of a free trial period, if offered, will be forfeited when the user purchases a subscription to that publication"
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "By using Cliffhanger, you agree to our Terms of Service (",
	        _react2.default.createElement(
	          "a",
	          {
	            href: (typeof window !== "undefined" ? window.location.origin : "") + "/legal/terms/"
	          },
	          "https://cliffhangerinteractive.com/legal/terms/"
	        ),
	        ") and Privacy Policy (",
	        _react2.default.createElement(
	          "a",
	          {
	            href: (typeof window !== "undefined" ? window.location.origin : "") + "/legal/privacy/"
	          },
	          "https://cliffhangerinteractive.com/legal/privacy/"
	        ),
	        ")."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "*Prices are equal to the value that \u201CApple\u2019s App Store Matrix\u201D determines is the equivalent subscription price in $USD"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "footer" },
	      _react2.default.createElement(
	        "a",
	        { href: "/legal/copyright/" },
	        "Copyright"
	      ),
	      _react2.default.createElement(
	        "a",
	        { href: "/legal/privacy/" },
	        "Privacy Policy"
	      ),
	      _react2.default.createElement(
	        "a",
	        { href: "/legal/subscription/" },
	        "Subscription"
	      ),
	      _react2.default.createElement(
	        "a",
	        { href: "/legal/terms/" },
	        "Terms of Service"
	      )
	    )
	  );
	};
	
	exports.default = SubscriptionPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-legal-subscription-js-6a75a80e610724f458e0.js